
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class PendriveTypesDialog extends Serenity.EntityDialog<PendriveTypesRow, any> {
        protected getFormKey() { return PendriveTypesForm.formKey; }
        protected getIdProperty() { return PendriveTypesRow.idProperty; }
        protected getLocalTextPrefix() { return PendriveTypesRow.localTextPrefix; }
        protected getNameProperty() { return PendriveTypesRow.nameProperty; }
        protected getService() { return PendriveTypesService.baseUrl; }
        protected getDeletePermission() { return PendriveTypesRow.deletePermission; }
        protected getInsertPermission() { return PendriveTypesRow.insertPermission; }
        protected getUpdatePermission() { return PendriveTypesRow.updatePermission; }

        protected form = new PendriveTypesForm(this.idPrefix);

    }
}